import React from "react";
import { Box, Card, Typography, Chip } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import styles from "./cisoDashboard.module.scss";

const protocolData = [
  { protocol: "Modbus", anomalies: 12, severity: "medium" },
  { protocol: "OPC-UA", anomalies: 8, severity: "low" },
  { protocol: "BACnet", anomalies: 15, severity: "high" },
  { protocol: "DNP3", anomalies: 5, severity: "low" },
  { protocol: "MQTT", anomalies: 18, severity: "high" },
];

const severityColor = {
  high: "#ef4444",
  medium: "#f59e0b",
  low: "#0CA6F2",
};

export const OTProtocolAnomaliesCard = () => {
  return (
    <Card
      className={styles.card}
      sx={{ width: "100%" }}
      variant="outlined"
      elevation={0}
    >
      <Typography className={styles.sectionHeading} fontWeight={600}>
        OT Protocol Anomalies
      </Typography>
      <Typography className={styles.subtitle}>
        Top anomalous protocols
      </Typography>
      <Box height={210} mt={5}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={protocolData} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis type="number" tick={{ fontSize: 12 }} />
            <YAxis
              type="category"
              dataKey="protocol"
              width={80}
              tick={{ fontSize: 12 }}
            />
            <Tooltip />
            <Bar dataKey="anomalies" radius={[0, 6, 6, 0]}>
              {protocolData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={severityColor[entry.severity]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
      <Box className={styles.badgeRow}>
        {protocolData.map((item) => (
          <Chip
            key={item.protocol}
            label={`${item.protocol}: ${item.severity}`}
            size="small"
            sx={{
              bgcolor: `${severityColor[item.severity]}22`,
              color: severityColor[item.severity],
            }}
          />
        ))}
      </Box>
    </Card>
  );
};

export default OTProtocolAnomaliesCard;
